import api from './api';

export const demoBookingService = {
  // Get all demo bookings with filters
  getDemoBookings: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.page) params.append('page', filters.page);
    if (filters.per_page) params.append('per_page', filters.per_page);
    
    const response = await api.get(`/tutor/demo-bookings?${params.toString()}`);
    return response.data;
  },

  // Get single booking details
  getDemoBookingById: async (id) => {
    const response = await api.get(`/tutor/demo-bookings/${id}`);
    return response.data;
  },

  // Update booking status
  updateBookingStatus: async (id, status, tutorResponse = '') => {
    const response = await api.patch(`/tutor/demo-bookings/${id}/status`, {
      status,
      tutor_response: tutorResponse,
    });
    return response.data;
  },

  // Get statistics
  getStatistics: async () => {
    const response = await api.get('/tutor/demo-bookings/statistics');
    return response.data;
  },
};
